// @ts-nocheck
/* eslint-disable */
export const chevronDownIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.29297 5.70718L2.70718 4.29297L8.00008 9.58586L13.293 4.29297L14.7072 5.70718L8.00008 12.4143L1.29297 5.70718Z" fill="currentColor"/></svg>`,
    name: 'chevron-down' as const
};